<template>
  <span :class="['color']" :style="{background, height: size + 'em', width: size + 'em'}" :title="background" />
</template>
<script>
export default {
  name: 'Color',
  props: {
    /**
     * CSS background color
     */
    background: {
      type: String,
      required: false,
      default: '#fff'
    },
    /**
     * Box dimensions
     */
    size: {
      type: Number,
      required: false,
      default: 1.25
    }
  }
}
</script>
<style>
.color
{
  display: inline-block;
  vertical-align: middle;
  border: solid 1px #fff;
}
</style>



// WEBPACK FOOTER //
// color.vue?5681a96e